<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  [isEmpty]="!tableReportData?.length"
  [emptyTitle]="'noTreatments' | translate"
  [emptyDescription]="'noTreatmentsInAdvice' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  [primaryActionText]="'printReport' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
>
  <agr-print-page
    [footerText]="
      ((isGBM$ | async) ? 'gbmWarningFooter' : 'fertilizationWarningFooter') | translate
    "
    [relatedPeople]="relatedPeople$ | async"
    [marginLeft]="true"
    [showPageNumber]="false"
  >
    <app-general-info></app-general-info>
    <div class="avoid-page-break spacing--margin-half-vertical">
      <app-fertilization-table
        [tableReportData$]="sortedTableReportData$"
        [showHeaders]="true"
        [isCollapsable]="false"
        (isDoneRendering)="updateIsDoneRendering($event)"
      ></app-fertilization-table>
    </div>
  </agr-print-page>
</agr-page-detail>
